// extracted by mini-css-extract-plugin
module.exports = {"userScaleChart":"userScale_userScaleChart__PMo1c","title":"userScale_title__2dEdQ"};